import type { RootState } from '../types';
import type { ApiOptions, ApiResponse } from './hub-api-request';

import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import rapidApiRequest, { ApiError } from './hub-api-request';

/**
 * Wrap `rapidApiRequest` with app-specific customisations:
 *
 * - If user is logged in, add their JWT to the request
 * - Map a path to a full server URL
 * - Dispatch a LOGOUT event if the server returns 401
 */
export default function useApiCallable() {
  const { user } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();

  return React.useCallback(
    async function callApi<T>(
      path: string,
      options: ApiOptions = {}
    ): Promise<ApiResponse<T>> {
      try {
        const response = await rapidApiRequest<T>(path, {
          jwt: user?.jwt,
          ...options,
        });
        return response;
      } catch (err: unknown) {
        if (err instanceof ApiError && err.response?.status === 401) {
          dispatch({ type: 'LOGOUT' });
        }
        throw err;
      }
    },
    [user?.jwt]
  );
}
